<template>
  <div>
    <app-header title="">
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-primary mt-2 mt-xl-0"
          v-c-modal:modal="{}"
        >
          <i class="far fa-plus"></i> Sign-Offs
        </button>
      </template>
    </app-header>

    <div class="container my-5">
        <h2>Sign-Offs.</h2>

      <c-data-list ref="dataList" :items="signoffs" @load="loadNextPage">
        <template v-slot:columns>
          <div class="col-12 col-lg-7 col-xl-7">
            <p>Company</p>
          </div>
          <div class="col-6 col-lg-1 col-xl-1">
            <p>Owner</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2">
            <p>Stage</p>
          </div>
          <div class="col-6 col-lg-2 col-xl-2 text-end">Status</div>
        </template>
        <template v-slot:default="slotProps">
          <sign-offs-list-item :sign-off="slotProps.item" />
        </template>
      </c-data-list>
    </div>

    <sign-offs-modal
      ref="modal"
      @created="newSignOffCreated"
      title="Sign-Off"
      :signOff="newSignOff"
      mode="create"
      :client-id="clientId"
      :contact-id="contactId"
    ></sign-offs-modal>
  </div>
</template>

<script>
import { isEqual, debounce } from "lodash";
import { mapState, mapActions } from "vuex";
import { Selectize } from "components/form/input";
import LazyLoading from "components/misc/LazyLoading";
import LaddaButton from "components/form/input/ladda-button.vue";
import { notify } from "utils";
import SignOffsModal from "./SignOffsModal";
import FilterDraw from "./FilterDraw";
import SignOffsListItem from "./SignOffsListItem"

import SignOffModel from "./../../models/sign-off.js";

export default {
  components: {
    Selectize,
    LaddaButton,
    LazyLoading,
    SignOffsModal,
    FilterDraw,
    SignOffsListItem
  },

  data: function () {
    return {
      loading: true,
      search_string: "",
      sort: "Newest",
      searching: false,
      deleted: false,
      toggleFilters: {
        draft: false,
        sent: false,
        signed: false,
        archived: false,
        overdue: false,
        template: false,
      },

      newSignOff: new SignOffModel(),
      clientId: null,
      contactId: null,
    };
  },
  created: function () {
    this.getSignOffs(this.filters);
  },

  computed: {
    ...mapState("signOff", { signoffs: "list", pagination: "pagination" }),

    filters() {
      return {
        params: {},
        sort: this.sort,
        search: this.search_string,
        draft: this.toggleFilters.draft,
        sent: this.toggleFilters.sent,
        signed: this.toggleFilters.signed,
        archived: this.toggleFilters.archived,
        overdue: this.toggleFilters.overdue,
        template: this.toggleFilters.template,
      };
    },

    haveSignOffs() {
      if (this.signoffs) {
        return this.signoffs.length > 0;
      }
    },
  },

  methods: {
    ...mapActions("signOff", {
      getSignOffs: "getList",
      getSignOffsForNextPage: "getListForNextPage",
    }),

    async loadNextPage(done) {
      try {
        await this.getSignOffsForNextPage(this.params);

        done();
      } catch (error) {
        done(true);
      }
    },

    newSignOffCreated() {
      this.getSignOffs()
    },

    clientCreated(clientId) {
      this.clientId = clientId;
    },

    contactCreated(contactId) {
      this.contactId = contactId;
    },

    dueIn(dueDate) {
      var today = moment();
      var d = moment(dueDate);
      return d.diff(today, "days");
    },

    updateFilters(filters) {
      Vue.set(this.toggleFilters, filters);
    },
  },
};
</script>

<style scoped>
</style>
